import TaskContainer from './TaskContainer'

import withTaskActions from 'Components/Tasks/withTaskActions'

export { TaskContainer }

export default withTaskActions(TaskContainer)
